// extracted by mini-css-extract-plugin
export default {"container":"Highlights_container__ZRGp9","block":"Highlights_block__uN4E3","title":"Highlights_title__sJCJ9","cta":"Highlights_cta__yDMNc"};